import React from 'react';
import AppHeader from '../components/AppHeader';
import TweetsWrapper from '../components/TweetsWrapper';
import InlineError from '../components/InlineError';

export default ({ styleClass, fontClass, config, error, generateCustomStyles }) => {
  return (
    <div
      className={`app ${styleClass} ${fontClass}`}
      style={{ backgroundColor: config.background_color }}
    >
      <style dangerouslySetInnerHTML={{ __html: generateCustomStyles(config) }}></style>
      <AppHeader
        style={config.style}
        backgroundColor={config.background_color}
        logoColor={config.logo_color}
      />
      <TweetsWrapper config={config} />
      {error && <InlineError error={error} text={config.configKey} />}
    </div>
  );
};
